import { render } from "./ShippingMethodsList.vue?vue&type=template&id=315c7f62&ts=true"
import script from "./ShippingMethodsList.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodsList.vue?vue&type=script&lang=ts"

import "./ShippingMethodsList.vue?vue&type=style&index=0&id=315c7f62&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__